import { defineMessages } from 'react-intl';

import Edit from './DateSocialShareEdit';
import View from './DateSocialShareView';

import iconSVG from './icons/date-share.svg';

defineMessages({
  date_social: {
    id: 'Date / Social share',
    defaultMessage: 'Date / Social share',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.dateSocialShareBlock = {
    id: 'dateSocialShareBlock',
    title: 'Date / Social share',
    group: 'layout',
    icon: iconSVG,
    view: View,
    edit: Edit,
    sidebarTab: 1,
    restricted: ({ properties, block }) =>
      properties.blocks_layout?.items?.find(
        (uid) => properties.blocks?.[uid]?.['@type'] === block.id,
      ),
    mostUsed: false,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
